import { UserApprovalOptions } from "@p0security/shared/types/workflow/types";
import { Flex } from "antd";
import { StyledTag } from "styles/StyledTags";
import { colors } from "styles/variables";

type Props = {
  approvalOptions: UserApprovalOptions;
};

export const ApprovalOptionsPreview: React.FC<Props> = ({
  approvalOptions,
}) => (
  <Flex gap={4}>
    {approvalOptions.allowOneParty && (
      <StyledTag color={colors.tagColors.red}>Allow one party</StyledTag>
    )}
    {approvalOptions.requireReason && (
      <StyledTag color={colors.tagColors.grey}>Require reason</StyledTag>
    )}
    {approvalOptions.requireDuration && (
      <StyledTag color={colors.tagColors.grey}>Require duration</StyledTag>
    )}
    {approvalOptions.requirePreapproval && (
      <StyledTag color={colors.tagColors.grey}>Require preapproval</StyledTag>
    )}
    {approvalOptions.breakGlassApprover && (
      <StyledTag color={colors.tagColors.grey}>Break-glass access</StyledTag>
    )}
  </Flex>
);
